import React from "react";
import AutoMode from "@mui/icons-material/AutoMode";
import SupervisorAccountOutlined from "@mui/icons-material/SupervisorAccountOutlined";
import "../styles/demo-execution-frame.css";

export default function DemoExecutionFrame({
  mode,
  label,
  className = "",
  children,
}) {
  const autonomous = mode === "autonomous";
  return (
    <div
      className={"demo-execution-frame " + className}
      data-execution-mode={autonomous ? "autonomous" : "supervised"}
    >
      {children}
      <svg
        className="demo-execution-trace"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="1" y="1" rx="5" pathLength="100" />
      </svg>
      <div
        className="demo-execution-status"
        role="status"
        aria-label={label + " execution status"}
        aria-atomic="true"
      >
        <span className="demo-execution-status-mode">
          {autonomous ? <AutoMode /> : <SupervisorAccountOutlined />}
          <strong>{autonomous ? "Autonomous" : "Supervised"}</strong>
        </span>
        <span className="demo-execution-status-detail">
          {autonomous ? "Guardrails on" : "Checkpoints on"}
        </span>
      </div>
    </div>
  );
}
